/* Arquivo userStoreVenda.js */
import { defineStore } from "pinia";


export const useUserVendaStore  = defineStore({


    id: "userVenda",

    persist: {
      enabled: true,
      strategies: [
          {
              key: 'userStoreVenda',
              storage: localStorage,
          }
      ]
  },

    state: () => ({

      GrupoDeProdutosPinia:[],
      GrupoDeProdutosSelecionadoPinia:null,

      SubGrupoDeProdutosPinia:[],
      SubGrupoDeProdutosSelecionadoPinia:null,

      onShowTela:{
        Cliente : false,
        NovoCliente : false,
        TabelaDePreco : false,
        FiltroGrupoSubGrupo: false,
        LeitorDeCodigoDeBarra: false,
      },


    }),

    getters: {

    },

    actions: {


        resetState() {


          this.onShowTela.Cliente = false;
          this.onShowTela.NovoCliente = false;
          this.onShowTela.TabelaDePreco = false;
          this.onShowTela.FiltroGrupoSubGrupo = false;
          this.onShowTela.LeitorDeCodigoDeBarra = false;


          this.GrupoDeProdutosPinia = [];
          this.GrupoDeProdutosSelecionadoPinia = null;

          this.SubGrupoDeProdutosPinia = [];
          this.SubGrupoDeProdutosSelecionadoPinia = null;

        },

        getonShowTela(key) {
          console.log('key', key);
          if (Object.prototype.hasOwnProperty.call(this.onShowTela, key)) {
            return this.onShowTela[key];
          }
          return false; // Or handle the case where the key doesn't exist
        },


        setGrupoDeProdutos(grupoDeProdutos) {
            this.GrupoDeProdutosPinia = grupoDeProdutos;
        },
        setGrupoDeProdutosSelecionado(GrupoSelecionado) {
            this.GrupoDeProdutosSelecionadoPinia = GrupoSelecionado;
        },
        getSubGrupoDeProdutos() {
            return this.SubGrupoDeProdutosPinia;
        },


        getGrupoDeProdutos() {
            return this.GrupoDeProdutosPinia;
        },

        setSubGrupoDeProdutos(SubgrupoDeProdutos) {
          this.SubGrupoDeProdutosPinia = SubgrupoDeProdutos;
      },
      setSubGrupoDeProdutosSelecionado(SubGrupoSelecionado) {
          this.SubGrupoDeProdutosSelecionadoPinia = SubGrupoSelecionado;
      },




        initialState() {

        },

    // ... outras ações ...
    },
});
